/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useRef } from 'react';
import classNames from 'classnames';
import { Modal } from '@zvuk-b2b/ui-kit';
import IconChevronLeft from '@zvuk-b2b/react-uikit/ui/icons/ChevronLeft';
import IconButton from '@zvuk-b2b/react-uikit/ui/IconButton';
import useMedia from '@zvuk-b2b/react-uikit/toolkit/useMedia';
import { MediaPreviewDialogProps } from './types';
import { ELEMENT_IDS } from './consts';
import { TEXTS } from './texts';
import styles from './index.module.scss';

const MediaPreviewDialog: React.FC<MediaPreviewDialogProps> = ({
  children,
  onClose,
  layoutClassName,
  overlayClassName,
  backButtonClassName,
  modalTestId,
  closeTestId,
}) => {
  const { isMobile } = useMedia();
  const openerRef = useRef(document.activeElement instanceof HTMLElement ? document.activeElement : null);

  return (
    <Modal
      open
      width="100vw"
      height="100dvh"
      style={{ zIndex: 'calc(var(--z-index-modal) + 1)' }}
      contentClassName={classNames(styles.dialog, layoutClassName)}
      overlayClassName={styles.overlay}
      data-testid={modalTestId}
      onCloseAutoFocus={(event) => {
        event.preventDefault();
        if (openerRef.current?.isConnected) openerRef.current.focus({ preventScroll: true });
      }}
      onOpenChange={(open) => {
        if (!open) onClose();
      }}>
      <Modal.Header className={styles.title}>{TEXTS.TITLE}</Modal.Header>
      {isMobile && (
        <IconButton
          onClick={onClose}
          className={backButtonClassName}
          elementId={ELEMENT_IDS.MOBILE_BACK}>
          <IconChevronLeft />
        </IconButton>
      )}
      {children}
      <div
        className={overlayClassName}
        data-testid={closeTestId}
        onClick={onClose}
      />
    </Modal>
  );
};

export default MediaPreviewDialog;
